function FifthPage (){
    return(
        <div className="w-[80%] mx-auto bg-gray-900 text-white rounded-xl mt-20">
            <div className="grid grid-cols-1 text-xs lg:text-lg font-semibold">
                <div className="flex justify-around items-center border-b border-gray-700 py-4 lg:py-2">
                    <h4>Bitcoin</h4>
                    <h4 className="text-purple-500">BTC</h4>
                    <h4 >$56,290.30</h4>
                    <h4 className="text-green-600">+1.68%</h4>
                    <img src="/images/graph.png" alt="" className="hidden md:block "/>
                    <button>Trade now →</button>
                </div>
                <div className="flex justify-around items-center border-b border-gray-700 py-4 lg:py-2">
                    <h4>Bitcoin</h4>
                    <h4 className="text-purple-500">BTC</h4>
                    <h4 >$56,290.30</h4>
                    <h4 className="text-green-600">+1.68%</h4>
                    <img src="/images/graph.png" alt="" className="hidden md:block "/>
                    <button>Trade now →</button>
                </div>
                <div className="flex justify-around items-center border-b border-gray-700 py-4 lg:py-2">
                    <h4>Bitcoin</h4>
                    <h4 className="text-purple-500">BTC</h4>
                    <h4 >$56,290.30</h4>
                    <h4 className="text-green-600">+1.68%</h4>
                    <img src="/images/graph.png" alt="" className="hidden md:block "/>
                    <button>Trade now →</button>
                </div>
                <div className="flex justify-around items-center border-b border-gray-700 py-4 lg:py-2">
                    <h4>Bitcoin</h4>
                    <h4 className="text-purple-500">BTC</h4>
                    <h4 >$56,290.30</h4>
                    <h4 className="text-green-600">+1.68%</h4>
                    <img src="/images/graph.png" alt="" className="hidden md:block "/>
                    <button>Trade now →</button>
                </div>
                <div className="flex justify-around items-center border-b border-gray-800 py-4 lg:py-2">
                    <h4>Bitcoin</h4>
                    <h4 className="text-purple-500">BTC</h4>
                    <h4 >$56,290.30</h4>
                    <h4 className="text-green-600">+1.68%</h4>
                    <img src="/images/graph.png" alt="" className="hidden md:block "/>
                    <button>Trade now →</button>
                </div>

            </div>
        </div>
    )
}

export default FifthPage